export default __webpack_public_path__ + "static/media/kubernetes.4ef698d4.svg";